import { MdOutlineAddLocationAlt, MdAddCircleOutline } from "react-icons/md";
import { LocationListType } from "utils/interfaces";
import LocationCardForm from "../../create-edit-school/cards/LocationCardForm";

interface AddLocationProps {
  locations: LocationListType[];
  setLocations: React.Dispatch<React.SetStateAction<LocationListType[]>>;
  setShowAddLocationPopUp: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddLocation: React.FC<AddLocationProps> = ({
  locations,
  setLocations,
  setShowAddLocationPopUp,
}) => {
  /**
   * Function that handle the add location pop up
   */
  const handleAddLocation = () => {
    setShowAddLocationPopUp(true);
  };

  /**
   * Function to handle the delete action
   */
  const deleteAction = (index: number) => {
    setLocations([...locations.slice(0, index), ...locations.slice(index + 1)]);
  };

  return (
    <div className="self-stretch inline-flex flex-col gap-1.5">
      <div className="justify-start text-neutral-500 text-xs font-normal font-sans uppercase leading-none tracking-wide">
        Location Details*
      </div>
      {locations.length === 0 && (
        <div
          className="self-stretch h-12 flex-col justify-start items-start gap-12 flex cursor-pointer"
          onClick={handleAddLocation}
        >
          <div className="w-full px-2 py-3 rounded-lg border border-dashed border-neutral-300 hover:bg-neutral-25 ease-in-out duration-150 justify-center items-center gap-2 inline-flex">
            <div className="w-6 h-6 relative">
              <MdOutlineAddLocationAlt className="w-full h-full fill-neutral-500" />
            </div>
            <div className="text-neutral-450 text-base font-normal font-sans leading-[19px]">
              Add a location
            </div>
          </div>
        </div>
      )}
      {locations.length > 0 && (
        <div className="self-stretch h-fit flex-col justify-start items-start gap-5 flex">
          {locations.map((location: LocationListType, index: number) => (
            <LocationCardForm
              key={index}
              index={index}
              location={location}
              deleteAction={deleteAction}
            />
          ))}
          <button
            className="group w-fit rounded justify-start items-center gap-2 flex cursor-pointer"
            onClick={handleAddLocation}
          >
            <div className="w-6 h-6 relative">
              <MdAddCircleOutline className="w-full h-full fill-secondary-600 group-hover:fill-secondary-700" />
            </div>
            <div className="text-secondary-600 group-hover:text-secondary-700 text-lg font-semibold font-sans leading-snug">
              Add additional location
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default AddLocation;
